// import { ConsultationType } from '../../../../../../types/models/consultations/consultation.types';
import { FormItem } from '../../../../../commons/Form/Form.types';
import { CreateConsultFirstStepFormSchema } from './CreateConsultFirstStepForm.types';

export const createConsultFirstStepData: FormItem<CreateConsultFirstStepFormSchema>[][] = [
  [
    {
      name: 'title',
      placeholder: 'Titre de la consultation...',
      label: 'Titre',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'ref',
      placeholder: 'Référence de la consultation...',
      label: 'Référence',
      type: 'text',
      required: false,
    },
  ],
  // [
  //   {
  //     name: 'type',
  //     placeholder: 'Type de la consultation...',
  //     label: 'Type de prestation',
  //     type: 'select',
  //     options: [
  //       {
  //         value: '7',
  //         label: 'Commerce de détail, grande distribution',
  //       },
  //       {
  //         value: '2',
  //         label: ConsultationType.TravauxPublics,
  //       },
  //       {
  //         value: '3',
  //         label: ConsultationType.Fournitures,
  //       },
  //       {
  //         value: '4',
  //         label: ConsultationType.Services,
  //       },
  //     ],
  //     required: true,
  //   },
  // ],
  [
    {
      name: 'fieldOfActivity',
      placeholder: "Domaine d'activité de la consultation...",
      label: "Domaine d'activité",
      type: 'select',
      required: true,
    },
  ],
  [
    {
      name: 'useActualAddress',
      label: 'Utiliser mon adresse',
      type: 'checkbox',
    },
  ],
  [
    {
      name: 'address',
      placeholder: 'Votre adresse...',
      label: 'Adresse',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'city',
      placeholder: 'Votre ville...',
      label: 'Ville',
      type: 'text',
      required: true,
      disabled: true,
    },
    {
      name: 'postalCode',
      placeholder: 'Votre code postal...',
      label: 'Code postal',
      type: 'text',
      required: true,
      disabled: true,
    },
  ],
  [
    {
      name: 'department',
      placeholder: 'Votre département...',
      label: 'Département',
      type: 'text',
      required: true,
      disabled: true,
    },
    {
      name: 'region',
      placeholder: 'Votre région...',
      label: 'Région',
      type: 'text',
      required: true,
      disabled: true,
    },
  ],
  [
    {
      name: 'is_premium',
      label: 'Garantie PubliConsult',
      questionText: 'Some text',
      type: 'checkbox',
    },
  ],
];
